import type { AskContext, AskLine } from './askTakiClient.js';

export type Resume = { id?: string; requestId: string; context: AskContext; turnId: string; messages: AskLine[] };
export type Recovery = { requestId: string; context: AskContext; messages: AskLine[]; turnId?: string; resumeId?: string };

/** Une connexion perdue pendant Continuer reprend le même tour visible. */
export function recoveryCheckpoint(resume?: Resume, recovery?: Recovery): Resume | undefined {
  return resume ?? (recovery?.turnId
    ? { id: recovery.resumeId, requestId: recovery.requestId, context: recovery.context,
        turnId: recovery.turnId, messages: recovery.messages } : undefined);
}
